/**
 * @deprecated Quarantined legacy — moved out of the Angular tree (WEB-8019). Do not import these
 * helpers in new code: use @upsales/components (Tooltip, Avatar, Paginator, …) or the modern
 * equivalents (e.g. Components/Misc/RatingLabel). Every consumer imports them; the
 * window.ReactTemplates global they were once registered on is gone (WEB-13675).
 */
import { Button, Checkbox, Icon, Tooltip } from '@upsales/components';
import _, { isEqual, isObject } from 'lodash';
import React from 'react';
import ReactCreateClass from 'create-react-class';

import SendBeam from 'Resources/SendBeam';
import globalTracker from 'App/babel/helpers/Tracker/Global';
import { SoliditetRow, soliditetRowStatics } from './listSoliditet';
import { dateCalendar } from 'App/helpers/DateHelpers';
import { openNewMailWithContact } from 'App/helpers/mailHelpers';
import TableHead from 'App/babel/components/TableHead';
import { Feature, hasSoftDeployAccess, isAvailable } from 'App/services/FeatureHelperStandalone';
import AppService from 'App/legacy/AppService';
import { callContact, callClient } from 'App/services/VoiceService';
import { getAvatar, getGravatar } from 'App/services/AvatarService';
import { formatURL } from 'App/helpers/linkFormatHelper';
import { currencyFormat } from 'Components/Filters/Currencies';
import { parseCustomFieldUserValues } from 'Services/ActionProperties';

import { isCustom } from 'App/helpers/filterHelper';
import { getCustomConfig } from 'App/helpers/filterHelperInstances';
import NotificationService from 'App/babel/NotificationService';
import CopyIcon, { COPY_ICON_HOST } from 'Components/CopyIcon/CopyIcon';

export const withTooltip = (component, title, options) => {
	const { placement, delayShow, ...opts } = options || {};
	const mappedOpts = { position: placement, delay: delayShow, ...opts };
	return (
		<Tooltip title={title} {...mappedOpts}>
			{component}
		</Tooltip>
	);
};

export const stopProp = function (e) {
	if (e.stopPropagation) {
		e.stopPropagation();
		e.nativeEvent.stopImmediatePropagation();
	}
};

export const upVoice = function (object, callType, value, related) {
	var phoneIntegration = AppService.getPhoneIntegration();
	var config = { href: null, target: null, onClick: null };
	const hasCallFromWeb = AppService.getSelf().userParams.callFromWeb;
	const { name } = object || {};

	if (!value) {
		return null;
	}

	var number = value.replace(/ /g, '');

	if (phoneIntegration) {
		config.onClick = function (e) {
			stopProp(e);

			if (!_.get(phoneIntegration, 'capabilities.useCallToLinks')) {
				e.preventDefault();
			}

			switch (callType) {
				case 'contact':
					callContact(object, number, related);
					break;
				case 'client':
					callClient(object, number, related);
					break;
			}
		};
	} else if (hasCallFromWeb) {
		config.onClick = async function (e) {
			e.stopPropagation();
			e.preventDefault();

			try {
				await SendBeam.makePhoneCall(number, name);

				NotificationService.add({
					style: NotificationService.style.SUCCESS,
					icon: 'mobile',
					title: 'click_to_call.callSent',
					body: 'click_to_call.tapNotification'
				});
			} catch (err) {
				NotificationService.add({
					style: NotificationService.style.ERROR,
					icon: 'times',
					title: 'default.error',
					body: 'default.somethingWrong'
				});
			}

			globalTracker.track('Send call to app: Clicked link');
		};
	} else {
		config.onClick = function (e) {
			e.stopPropagation();
		};
	}

	var metadata = AppService.getMetadata();
	var telType;
	if (_.get(phoneIntegration, 'capabilities.useCallToLinks')) {
		telType = _.get(phoneIntegration, 'capabilities.useCallToLinks');
	} else {
		telType = metadata.params.callToType;
	}

	var telTarget = metadata.params.callToTarget;
	var telPrefix = metadata.params.telPrefix;

	var prefixedNumber = '';

	for (var i = 0; i < number.length; i++) {
		if (i === 0 && number[i] === '0' && telPrefix && telPrefix.length) {
			prefixedNumber += telPrefix;
		} else if (i === 0 && number[i] === '+') {
			prefixedNumber += number[i];
		} else if (/[0-9]/.test(number[i])) {
			prefixedNumber += number[i];
		}
	}

	var href = telType + prefixedNumber;

	config.href = href;
	config.target = telTarget;

	return config;
};

export const emptyTD = function (text, key) {
	return <td key={key}>{text || ''}</td>;
};

// Legacy arg order differs from App/helpers/DateHelpers' dateCalendar
export const toolsDateCalendar = function (date, format, calendarTimeToday) {
	return dateCalendar(date, calendarTimeToday, format);
};

export const accountHref = ReactCreateClass({
	displayName: 'accountHref',
	getInitialState: function () {
		var customerId = AppService.getCustomerId();

		return {
			customerId: customerId,
			activityId: this.props.activityId ? '?activityId=' + this.props.activityId : '',
			id: this.props.id,
			text: this.props.text,
			isExternal: this.props.isExternal,
			sub: this.props.sub ? this.props.sub + '/' : ''
		};
	},
	shouldComponentUpdate: function (newProps) {
		return this.state.text !== newProps.text;
	},
	UNSAFE_componentWillUpdate: function (newProps) {
		var self = this;
		// Set the state text if it was changed
		if (self.state.text !== newProps.text) {
			self.setState({ text: newProps.text });
		}
	},
	render: function () {
		var text = _.trim(this.state.text);
		if ((!text.length || text === ' ') && !this.props.sub) {
			text = Tools.$translate('default.noName');
		}

		if (this.state.isExternal) {
			return <span>{text}</span>;
		}
		const useReactCard = hasSoftDeployAccess('REACT_CLIENT_CARD');
		const href = useReactCard
			? '#/accounts/' + this.state.id + '/' + this.state.sub
			: '#/' +
			  this.state.customerId +
			  '/accounts/' +
			  this.state.id +
			  '/' +
			  this.state.activityId +
			  this.state.sub;

		return (
			<a href={href} onClick={stopProp}>
				{text}
			</a>
		);
	}
});

export const contactHref = props => {
	let text = _.trim(props.text);
	if ((!text.length || text === ' ') && !props.sub) {
		text = <i>{Tools.$translate('default.noName')}</i>;
	}
	const sub = props.sub ? props.sub + '/' : '';

	return (
		<a
			href={`#/${props.customerId}/contacts/${props.id}/${sub}`}
			onClick={e => {
				stopProp(e);
				if (props.onClick && typeof props.onClick === 'function') {
					props.onClick(e);
				}
			}}
		>
			{text}
		</a>
	);
};

export const mailTo = function (customerId, contact, style) {
	// if user can use mail-function
	var click = function (e) {
		stopProp(e);

		const mailActivated = AppService.getMetadata()?.map.mailActivated;
		// Only use the drawer if mail is activated, otherwise let the native mailto work
		if (isAvailable(Feature.EMAIL) && mailActivated) {
			e.preventDefault();

			if (contact.email) {
				openNewMailWithContact(contact);
			}
		}
	};

	const link = (
		<a style={style} href={'mailto:' + contact.email} onClick={click.bind(this)} target="_top">
			{contact.email}
		</a>
	);

	if (!contact.email || !hasSoftDeployAccess('EMAIL_COPY_BUTTON')) {
		return link;
	}

	return (
		<span className={`${COPY_ICON_HOST} ${COPY_ICON_HOST}--inline`}>
			{link}
			<CopyIcon value={contact.email} revealOnHover />
		</span>
	);
};

export const rowTool = ReactCreateClass({
	displayName: 'rowTool',
	getDefaultProps: function () {
		return {
			onClick: function () {},
			className: '',
			icon: ''
		};
	},
	shouldComponentUpdate: function (nextProps) {
		return !isEqual(this.props, nextProps);
	},
	click: function (e) {
		stopProp(e);
		this.props.onClick(this.props.item, e);
	},
	render: function () {
		const btnClass = this.props.className;
		var btn = (
			<Button type="link" className={'row-tool ' + btnClass} onClick={this.click}>
				{this.props.icon ? <Icon name={this.props.icon} /> : null}
				{this.props.children ? this.props.children : null}
			</Button>
		);

		if (this.props.loading) {
			return (
				<span className="row-tool-loading">
					<b className="fa fa-spinner fa-spin" />
				</span>
			);
		}

		return this.props.show ? (
			this.props.tooltip ? (
				<Tooltip title={this.props.tooltip} position="left">
					{btn}
				</Tooltip>
			) : (
				btn
			)
		) : null;
	}
});

export const leadStatus = ReactCreateClass({
	displayName: 'leadStatus',
	getTimeStr: function (date) {
		var momentDate = moment(new Date(date));
		if (momentDate.isValid()) {
			// If date is in future we display date calendar
			var today = new Date();
			if (momentDate.isSame(today, 'day') || momentDate.isAfter(today)) {
				var d = momentDate.calendar();

				// the d is '0' if date is not today, tomorrow or yesterady (configured in momentLanguageConfig in app.js)
				if (d !== '0') {
					return d;
				}
				return momentDate.format('L');
			} else {
				// var isIE = window.Tools.browserService.isIE();
				// // check for IE since moment obj becomes weird in IE..
				// return isIE ? moment(momentDate.format('L')).fromNow() : momentDate.fromNow(); // else we display ex. "4 years ago"
			}
		} else {
			return date;
		}
	},
	render: function () {
		var $translate = window.Tools.$translate;
		const isContact = this.props.isContact;
		var activityClass = '';
		const entity =
			hasSoftDeployAccess('TODO_LIST') && hasSoftDeployAccess('REMOVE_ACTIVITIES') ? 'Task' : 'Activity';
		var activityTooltip = isContact ? `search.contactHasNo${entity}` : `search.accountHasNo${entity}`;
		var activityDate = null;
		var opportunityClass = '';
		var opportunityTooltip = isContact ? 'search.contactHasNoOpportunity' : 'search.accountHasNoOpportunity';
		var opportunityDate = null;
		var orderClass = '';
		var orderTooltip = isContact ? 'search.contactHasNoOrder' : 'search.accountHasNoOrder';
		var orderDate = null;
		var classStyle = 'indicator-wrapper indicator-' + (this.props.size || 'sm');

		if (this.props.activity) {
			activityClass = 'indicator-active';
			activityTooltip = isContact ? `search.contactHas${entity}` : `search.accountHas${entity}`;
			activityDate = this.getTimeStr(this.props.activity);
		} else if (this.props.activityOld) {
			activityClass = 'indicator-inverted';
			activityTooltip = isContact ? `search.contactHad${entity}` : `search.accountHad${entity}`;
			activityDate = this.getTimeStr(this.props.activityOld);
		}

		if (this.props.appointment) {
			activityClass = 'indicator-active';
			activityTooltip = isContact ? 'search.contactHasAppointment' : 'search.accountHasAppointment';
			activityDate = this.getTimeStr(this.props.appointment);
		} else if (this.props.appointmentOld && !this.props.activity) {
			activityClass = 'indicator-inverted';
			activityTooltip = isContact ? 'search.contactHadAppointment' : 'search.accountHadAppointment';
			activityDate = this.getTimeStr(this.props.appointmentOld);
		}

		if (this.props.opportunity) {
			opportunityClass = 'indicator-active';
			opportunityTooltip = isContact ? 'search.contactHasOpportunity' : 'search.accountHasOpportunity';
			opportunityDate = this.getTimeStr(this.props.opportunity);
		} else if (this.props.opportunityOld) {
			opportunityClass = 'indicator-inverted';
			opportunityTooltip = isContact ? 'search.contactHadOpportunity' : 'search.accountHadOpportunity';
			opportunityDate = this.getTimeStr(this.props.opportunityOld);
		}

		if (this.props.order) {
			orderClass = 'indicator-active';
			orderTooltip = isContact ? 'search.contactHasOrder' : 'search.accountHasOrder';
			orderDate = this.getTimeStr(this.props.order);
		} else if (this.props.orderOld) {
			orderClass = 'indicator-inverted';
			orderTooltip = isContact ? 'search.contactHadOrder' : 'search.accountHadOrder';
			orderDate = this.getTimeStr(this.props.orderOld);
		}

		return (
			<div key={'leadStatus-' + this.props.theKey} className={classStyle} onClick={stopProp}>
				<Tooltip
					title={$translate(activityTooltip) + (activityDate ? ', ' + activityDate : '')}
					position={this.props.tooltipPlacement || 'top'}
					key={'activity_' + this.props.theKey}
					style={{ display: 'inline-block' }}
				>
					<div className={'first ' + activityClass}>
						<i className="fa fa-check" />
					</div>
				</Tooltip>

				<Tooltip
					title={$translate(opportunityTooltip) + (opportunityDate ? ', ' + opportunityDate : '')}
					position={this.props.tooltipPlacement || 'top'}
					key={'opportunity_' + this.props.theKey}
					style={{ display: 'inline-block' }}
				>
					<div className={'second ' + opportunityClass}>
						<i className="up-icon-pipeline" />
					</div>
				</Tooltip>

				<Tooltip
					title={$translate(orderTooltip) + (orderDate ? ', ' + orderDate : '')}
					position={this.props.tooltipPlacement || 'top'}
					key={'order_' + this.props.theKey}
					style={{ display: 'inline-block' }}
				>
					<div className={'third ' + orderClass}>
						<i className="fa fa-usd" />
					</div>
				</Tooltip>
			</div>
		);
	}
});

export const checkboxTD = ReactCreateClass({
	displayName: 'checkbox-td',
	getDefaultProps: function () {
		return {
			idField: 'id'
		};
	},
	click: function (e) {
		stopProp(e);

		if (!this.isDisabled()) {
			this.props.tools.$multiSelect.toggle(_.get(this.props.item, this.props.idField));
		}
	},
	isChecked: function () {
		return this.props.tools.$multiSelect.isChecked(_.get(this.props.item, this.props.idField));
	},
	isDisabled: function () {
		return this.props.tools.$multiSelect.allSelectedFilter;
	},
	render: function () {
		return (
			<td key="checkbox-td" className="column-checkbox" onClick={this.click}>
				<Checkbox
					disabled={this.isDisabled()}
					checked={this.isChecked() || this.isDisabled()}
					onClick={this.click}
					size="xs"
				/>
			</td>
		);
	}
});

export const genericTD = function (props, attrs, col, item, key) {
	key = key || 'blank';
	var m;
	if (isCustom(col)) {
		var cf = getCustomConfig(col, props.customFields);
		if (
			!item.$mappedCustom ||
			item.$mappedCustom[cf.field] === null ||
			item.$mappedCustom[cf.field] === undefined ||
			item.$mappedCustom[cf.field] === ''
		) {
			return emptyTD('', key);
		}

		if (cf.$field.datatype === 'Boolean') {
			return (
				<td key={key}>
					{item.$mappedCustom[cf.field].value
						? Tools.$translate('default.yes')
						: Tools.$translate('default.no')}
				</td>
			);
		} else if (cf.$field.datatype === 'Date') {
			if (!item.$mappedCustom[cf.field].value) {
				return emptyTD('', key);
			}
			m = moment(item.$mappedCustom[cf.field].value);
			if (!m.isValid() || !item.$mappedCustom[cf.field].value) {
				return emptyTD('', key);
			}
			return <td key={key}>{m.format('L')}</td>;
		} else if (cf.$field.datatype === 'Link') {
			const linkValue = item.$mappedCustom[cf.field].value;
			return (
				<td key={key}>
					<a
						target="_blank"
						href={hasSoftDeployAccess('FORMAT_CUSTOM_FIELD_LINKS') ? formatURL(linkValue) : linkValue}
						onClick={stopProp}
					>
						{item.$mappedCustom[cf.field].value}
					</a>
				</td>
			);
		} else if (_.includes(['User', 'Users'], cf.$field.datatype)) {
			var users = item.$mappedCustom[cf.field].value;
			if (!users) {
				return <td key={key}>{item.$mappedCustom[cf.field].value}</td>;
			}
			var customFieldValuesArray = parseCustomFieldUserValues(users);

			return <td key={key}>{customFieldValuesArray}</td>;
		} else {
			return <td key={key}>{item.$mappedCustom[cf.field].value}</td>;
		}
	} else {
		if (!attrs[col]) {
			return null;
		}
		if (attrs[col].standardField) {
			var selectOptions = AppService.getStaticValues(attrs[col].standardField);
			var selectedOption = _.find(selectOptions, { id: item[attrs[col].field] });
			if (selectedOption) {
				return <td key={key}>{selectedOption.name}</td>;
			}
		}

		if (attrs[col].type === 'Date') {
			if (!item[col]) {
				return emptyTD('', key);
			}
			m = moment(item[col]);
			if (!m.isValid()) {
				return emptyTD('', key);
			}

			return <td key={key}>{moment(item[col]).format('L')}</td>;
		}

		var value = item[col];
		if (value && attrs[col].displayAttr) {
			value = value[attrs[col].displayAttr];
		} else if (!value && attrs[col].field) {
			value = item[attrs[col].field];
		}

		if (attrs[col].displayType === Tools.DisplayType.Currency && (value || value === 0)) {
			value = currencyFormat(value, item.currency || 'SEK');
			return <td key={key}>{value}</td>;
		}

		if (isObject(value)) {
			return emptyTD('', key);
		}

		return <td key={key}>{value}</td>;
	}
};

export const usersText = function (users) {
	if (users.length > 1) {
		var str = _.pluck(users.slice(1), 'name').join('\n');

		return (
			<span>
				{users[0].name} {Tools.$translate('default.and').toLowerCase() + ' '}
				<Tooltip placement="left" title={str}>
					<b onClick={stopProp}>
						{users.length - 1} {Tools.$translate('filters.more').toLowerCase()}
					</b>
				</Tooltip>
			</span>
		);
	} else {
		return users[0] ? users[0].name : Tools.$translate('default.noUser');
	}
};

export const campaignsText = function (campaigns, props, customerId) {
	if (campaigns.length > 1) {
		var str = _.pluck(campaigns.slice(1), 'name').join('\n');

		return (
			<span>
				{campaigns[0].name} {props.$translate('default.and').toLowerCase() + ' '}
				<Tooltip placement="left" title={str}>
					<b onClick={stopProp}>
						{campaigns.length - 1} {props.$translate('filters.more').toLowerCase()}
					</b>
				</Tooltip>
			</span>
		);
	} else if (customerId) {
		// If customerId is defined and there are only one campaign --> make it a link
		return (
			<a href={'#/' + customerId + '/campaigns/' + campaigns[0].id + '/'} onClick={stopProp}>
				{campaigns[0].name}
			</a>
		);
	} else {
		return campaigns[0].name;
	}
};

export const categoriesText = function (categories, props) {
	if (categories.length > 1) {
		var str = _.pluck(categories.slice(1), 'name').join('\n');

		return (
			<span>
				{categories[0].name} {props.$translate('default.and').toLowerCase() + ' '}
				<Tooltip placement="left" title={str}>
					<b onClick={stopProp}>
						{categories.length - 1} {props.$translate('filters.more').toLowerCase()}
					</b>
				</Tooltip>
			</span>
		);
	} else {
		return categories[0].name;
	}
};

export const contactsText = function (customerId, contacts, props, sub) {
	if (!props) {
		props = Tools;
	}

	if (!contacts.length) {
		return emptyTD();
	}

	var standardFields = AppService.getMetadata().standardFields.Contact;
	const hasNewFields = hasSoftDeployAccess('NEW_FIELDS');
	var showSalutations = hasNewFields && standardFields.Salutation && standardFields.Salutation.active;

	sub = sub ? sub + '/' : '';
	var firstContact = contacts[0];

	var name =
		showSalutations && firstContact.salutation
			? firstContact.salutation.value + ' ' + firstContact.name
			: firstContact.name;
	var link = (
		<a href={'#/' + customerId + '/contacts/' + firstContact.id + '/' + sub} onClick={stopProp}>
			{name}
		</a>
	);

	if (contacts.length > 1) {
		var str = _.pluck(contacts.slice(1), 'name').join('\n');

		return (
			<span>
				{link}
				{' ' + props.$translate('default.and').toLowerCase() + ' '}
				<Tooltip placement="left" title={str}>
					<b onClick={stopProp}>
						{contacts.length - 1} {props.$translate('filters.more').toLowerCase()}
					</b>
				</Tooltip>
			</span>
		);
	} else {
		return link;
	}
};

// The only template table is rendered with (LegacyFindProspects/root.jsx).
const rowComponents = { soliditetRow: SoliditetRow };
const rowStatics = { soliditetRow: soliditetRowStatics };

export const table = ReactCreateClass({
	displayName: 'table',
	getInitialState: function () {
		return {};
	},
	getSort: function (val, type) {
		if (val === null || val === undefined) {
			return null;
		}

		if (type === 'Date' && val.getTime) {
			return val.getTime();
		}

		if (type === 'String' && val.toLowerCase) {
			return val.toLowerCase();
		}

		if ((type === 'Currency' || type === 'Percent' || type === 'Discount') && !isNaN(parseFloat(val))) {
			return parseFloat(val);
		}

		if ((type === 'Number' || type === 'Integer') && !isNaN(parseInt(val))) {
			return parseInt(val);
		}

		return val;
	},
	sortFn: function (item, col) {
		var $parse = this.props.tools.$parse;
		var customFields = this.props.tools.customFields;

		if (isCustom(col)) {
			var cf = getCustomConfig(col, customFields);
			if (
				!item.$mappedCustom ||
				item.$mappedCustom[cf.field] === null ||
				item.$mappedCustom[cf.field] === undefined
			) {
				return null;
			}

			return this.getSort(item.$mappedCustom[cf.field].value, cf.$field.datatype);
		} else {
			var a = $parse(col)(item);

			return this.getSort(a, this.props.attrs[col].type);
		}
	},
	// eslint-disable-next-line no-unused-vars
	doSort: function (rows) {
		// eslint-disable-line no-unused-vars
		var self = this;

		if (!self.props.currentSorting) {
			return;
		}

		var col = self.props.currentSorting.attribute;

		if (self.props.attrs[col] || isCustom(col)) {
			var ascending = self.props.currentSorting.ascending;
			// eslint-disable-next-line no-unused-vars
			rows = rows.sort(function (A, B) {
				var itemA = A.props.item;
				var itemB = B.props.item;

				var aValue = self.sortFn(itemA, col),
					bValue = self.sortFn(itemB, col);

				if (aValue === null) {
					return 1;
				}
				if (bValue === null) {
					return -1;
				}

				if (aValue === bValue) {
					bValue = itemA.id;
					aValue = itemB.id;
				}
				if (ascending) {
					if (typeof aValue === 'string') {
						return aValue.localeCompare(bValue, 'sv');
					}
					return aValue > bValue ? 1 : -1;
				}
				if (typeof bValue === 'string') {
					return bValue.localeCompare(aValue, 'sv');
				}
				return aValue > bValue ? -1 : 1;
			});
		}
	},
	render: function () {
		var statics = rowStatics[this.props.template] ? rowStatics[this.props.template](this.props.tools) : {};

		var rows;

		if (this.props.useReactSupportRows) {
			if (this.props.loading) {
				rows = (
					<tr className="load-row">
						<td colSpan={'100'}>
							<b className="fa fa-refresh fa-spin" />
						</td>
					</tr>
				);
			} else if (this.props.data && this.props.data.length) {
				rows = this.props.data.map(
					function (item) {
						return React.createElement(rowComponents[this.props.template], {
							item: item,
							columns: this.props.columns,
							tools: this.props.tools,
							statics: statics,
							attrs: this.props.attrs
						});
					}.bind(this)
				);

				if (!this.props.skipSort) {
					this.doSort(rows);
				}
			} else {
				var $translate = Tools.$translate;
				var noResultString = $translate('noResult.default');
				rows = (
					<tr className="no-result-row">
						<td colSpan={'100'}>{noResultString}</td>
					</tr>
				);
			}
		} else {
			rows = this.props.data.map(
				function (item) {
					return React.createElement(rowComponents[this.props.template], {
						item: item,
						columns: this.props.columns,
						tools: this.props.tools,
						statics: statics,
						attrs: this.props.attrs
					});
				}.bind(this)
			);

			if (!this.props.skipSort) {
				this.doSort(rows);
			}
		}

		var classes = 'main-table';

		if (this.props.sticky) {
			classes += ' fixed-header';
		}

		return (
			<table className={classes} key="main-table" ref={this.props.ref}>
				<TableHead
					data={this.props.data}
					columns={this.props.columns}
					tools={this.props.tools}
					columnTemplates={this.props.columnTemplates}
					currentSorting={this.props.currentSorting}
					length={this.props.data.length}
					categoryTypes={this.props.categoryTypes}
					actions={this.props.actions}
				/>

				<tbody key="main-tbody">{rows}</tbody>
			</table>
		);
	}
});

export const eventTypes = ReactCreateClass({
	displayName: 'eventTypes',
	render: function () {
		var $translate = window.Tools.$translate;
		var visitTooltip = 'event.types.Visit';
		var mailTooltip = 'event.types.Mail';
		var formTooltip = 'event.types.Form';

		var visitClass = 'first';
		var mailClass = 'second';
		var formClass = 'third';

		if (this.props.account.hasVisit) {
			visitClass = 'first indicator-inverted';
		}

		if (this.props.account.hasMail) {
			mailClass = 'second indicator-inverted';
		}

		if (this.props.account.hasForm) {
			formClass = 'third indicator-inverted';
		}

		var size = this.props.size ? 'indicator-' + this.props.size : 'indicator-sm';

		return (
			<div key={'event-type-' + this.props.theKey} className={'indicator-wrapper indicator-orange ' + size}>
				<Tooltip
					title={$translate(visitTooltip)}
					position="top"
					key={'visit-' + this.props.theKey}
					style={{ display: 'inline-block' }}
				>
					<div className={visitClass}>
						<i className="fa fa-globe" />
					</div>
				</Tooltip>

				<Tooltip
					title={$translate(mailTooltip)}
					position="top"
					key={'mail-' + this.props.theKey}
					style={{ display: 'inline-block' }}
				>
					<div className={mailClass}>
						<i className="fa fa-envelope" />
					</div>
				</Tooltip>

				<Tooltip
					title={$translate(formTooltip)}
					position="top"
					key={'form-' + this.props.theKey}
					style={{ display: 'inline-block' }}
				>
					<div className={formClass}>
						<i className="fa fa-file" />
					</div>
				</Tooltip>
			</div>
		);
	}
});

export const mailStats = ReactCreateClass({
	displayName: 'mailStats',
	render: function () {
		var tools = this.props.tools;
		var openedTooltip = 'event.contactopen';
		var clickedTooltip = 'mail.mailEvent.click';
		var submittedTooltip = 'event.form.submited';

		var readClass = 'first';
		var clickedClass = 'second';
		var submittedClass = 'third';

		if (this.props.read) {
			readClass += ' indicator-active';
		}

		if (this.props.clicked) {
			clickedClass += ' indicator-active';
		}

		if (this.props.submitted) {
			submittedClass += ' indicator-active';
		}

		return (
			<div key={'event-type-' + this.props.theKey} className="indicator-wrapper indicator-sm indicator-orange">
				<div key="read" className={readClass}>
					{this.props.read ? (
						<Tooltip
							title={tools.$translate(openedTooltip) + '\n' + moment(this.props.read).format('L LT')}
							position="top"
							key="visit-tt"
						>
							<i className="fa fa-eye" />
						</Tooltip>
					) : (
						<i className="fa fa-eye" />
					)}
				</div>

				<div key="clicked" className={clickedClass}>
					{this.props.clicked ? (
						<Tooltip
							title={tools.$translate(clickedTooltip) + '\n' + moment(this.props.clicked).format('L LT')}
							position="top"
							key="mail-tt"
						>
							<i className="fa fa-mouse-pointer" />
						</Tooltip>
					) : (
						<i className="fa fa-mouse-pointer" />
					)}
				</div>

				{this.props.hideSubmit ? (
					''
				) : (
					<div key="submitted" className={submittedClass}>
						{this.props.submitted ? (
							<Tooltip
								title={
									tools.$translate(submittedTooltip) +
									'\n' +
									moment(this.props.submitted).format('L LT')
								}
								position="top"
								key="form-tt"
							>
								<i className="fa fa-wpforms" />
							</Tooltip>
						) : (
							<i className="fa fa-wpforms" />
						)}
					</div>
				)}
			</div>
		);
	}
});

export const avatar = ReactCreateClass({
	getInitialState: function () {
		var self = this;
		var size = self.props.size ? self.props.size : 30;
		var avatar = self.props.avatar;

		return {
			user: self.props.user,
			size: size,
			avatar: avatar
		};
	},

	getDefaultProps: function () {
		return {
			avatar: { initials: '', url: '', gravatar: false }
		};
	},
	downloadAvatar: function () {
		var self = this;

		getAvatar(self.props.user, { skipGravatarCall: self.props.skipGravatarCall })
			.then(function (avatar) {
				self.setState({ avatar: avatar });
			})
			.catch(err => console.error(err));
	},
	componentDidUpdate: function (prevProps) {
		// change to gravatar or initials
		if (prevProps.avatar.url && !this.props.avatar.url) {
			this.downloadAvatar();
		}
		if ((prevProps.user || {}).id !== (this.props.user || {}).id) {
			this.setState({ avatar: this.props.avatar });
			this.downloadAvatar();
		}
	},
	componentDidMount: function () {
		this.downloadAvatar();
	},
	onError: function () {
		if (this.state.avatar.url.indexOf('gravatar') === -1) {
			this.setState({
				avatar: getGravatar(this.props.user, { notFoundError: false }),
				hasError: true
			});
		}
	},
	UNSAFE_componentWillUpdate: function (newProps, newState) {
		var self = this;
		var size = this.props.size ? this.props.size : 30;
		// Set the state text if it was changed --> Only check if not assign before.. shallComponentUpdate check if visit has an assign
		if (newProps.user && newProps.user.id) {
			var avatar = this.props.avatar.url ? this.props.avatar : newState.avatar;
			if (newProps.avatar && newProps.avatar.url) {
				avatar.url = newProps.avatar.url;
			}

			if (this.state.avatar.url !== avatar.url) {
				self.setState({ user: this.props.user, size: size, avatar: avatar });
			}
		}
	},
	render: function () {
		var size = this.state.size;

		if (this.props.user && this.props.user.name) {
			var avatar = this.state.avatar;
			var tag = avatar.gravatar ? <img className="img" src={avatar.url} onError={this.onError} /> : null;
			var innerDivStyle = _.merge(
				{
					display: avatar.initials.length ? 'block' : 'none',
					lineHeight: size + 'px'
				},
				this.props.innerStyle || {}
			);

			var outerDivStyle = _.merge(
				{
					width: size,
					height: size,
					fontSize: parseInt(size) / 2 + 'px',
					marginTop: '3px'
				},
				this.props.style || {}
			);

			var spanStyle = {
				lineHeight: size + 'px'
			};

			var classNames = 'generic-avatar round';

			if (this.props.className) {
				classNames += ' ' + this.props.className;
			}

			return (
				<div className={classNames} style={outerDivStyle} id={this.props.id || null}>
					<div style={innerDivStyle} className="color">
						<span className="name" style={spanStyle}>
							{avatar.initials}
						</span>
					</div>
					{tag}
				</div>
			);
		} else {
			return <div />;
		}
	}
});

export const pagination = ReactCreateClass({
	click: function (pageNumber) {
		if (this.props.searchStr) {
			this.props.onChange(this.props.searchStr, pageNumber);
		} else {
			this.props.onChange(null, pageNumber);
		}
	},
	makePage: function (number, text, isActive) {
		return {
			number: number,
			text: text,
			active: isActive
		};
	},
	getPages: function (maxSize, currentPage, totalPages) {
		var rotate = true;
		var pages = [];
		// Default page limits
		var startPage = 1,
			endPage = totalPages;
		var isMaxSized = maxSize && maxSize < totalPages;

		// recompute if maxSize
		if (isMaxSized) {
			if (rotate) {
				// Current page is displayed in the middle of the visible ones
				startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
				endPage = startPage + maxSize - 1;

				// Adjust if limit is exceeded
				if (endPage > totalPages) {
					endPage = totalPages;
					startPage = endPage - maxSize + 1;
				}
			} else {
				// Visible pages are paginated with maxSize
				startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

				// Adjust last page if limit is exceeded
				endPage = Math.min(startPage + maxSize - 1, totalPages);
			}
		}

		if (startPage === 2) {
			pages.push(this.makePage(1, 1, false));
		}
		if (startPage > 2) {
			pages.push(this.makePage(1, 1, false));
			pages.push(this.makePage(startPage - 1, '...', false));
		}

		// Add page number links
		for (var number = startPage; number <= endPage; number++) {
			pages.push(this.makePage(number, number, number === currentPage));
		}

		if (endPage < totalPages - 1) {
			pages.push(this.makePage(endPage + 1, '...', false));
			pages.push(this.makePage(totalPages, totalPages, false));
		}
		if (endPage === totalPages - 1) {
			pages.push(this.makePage(totalPages, totalPages, false));
		}

		// Add links to move between page sets
		if (isMaxSized && !rotate) {
			if (startPage > 1) {
				// prevPageSet
				pages.unshift(this.makePage(startPage - 1, '...', false));
			}

			if (endPage < totalPages) {
				// nextPageSet
				pages.push(this.makePage(endPage + 1, '...', false));
			}
		}

		return pages;
	},
	render: function () {
		var self = this;
		var maxSize = self.props.maxSize;
		var totalPages = Math.ceil(self.props.totalItems / self.props.itemsPerPage);
		var currentPage = self.props.currentPage;

		var _pages = this.getPages(maxSize, currentPage, totalPages);
		var pages = _.map(_pages, function (page) {
			return (
				<li key={'pagination-' + page.number} className="number">
					<a
						className={page.active ? 'current number' : 'number'}
						onClick={self.click.bind(self, page.number)}
					>
						{page.number}
					</a>
				</li>
			);
		});

		return (
			<div className="up-paginator-wrap">
				<ul className="up-paginator">{pages}</ul>
			</div>
		);
	}
});
